import React from 'react';
import properties from '../../constants/Properties';
import mouseUtils from '../../components/utils/MouseUtils';
import appParameters from '../utils/AppParameters';
import { printMode, printTemplate } from '../../actions/MenuActions';
import locales from '../../locales/LocalesManager';

const Title = React.createClass({
    render() {
        const titleStyle = {
            position: 'absolute',
            backgroundColor: properties.BROWSER_SELECTED_COLOR,
            width: this.props.width,
            height: this.props.height,
            top: this.props.top,
            left: this.props.left,
            cursor: 'default',
            userSelect: 'none',
            userDrag: 'none',
            WebkitUserSelect: 'none'
        };

        const spanStyle = {
            color: 'white',
            fontSize: 16,
            cursor: 'default',
            position: 'absolute',
            top: 11,
            paddingLeft: 10,
            paddingTop: 5
        };

        return (
            <div style={titleStyle}>
                <span style={spanStyle}>{locales.getCaption('PrintMenuTitle', 'other')}</span>
            </div>
        );
    }
});

const Button = React.createClass({
    getInitialState () {
        return {
            isOver: false
        };
    },
    onMouseIn () {
        this.setState({
            isOver: true
        });
    },
    onMouseOut () {
        this.setState({
            isOver: false
        });
    },
    onClick (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        switch (this.props.index) {
            case 0: {
                this.props.dispatch(printTemplate(0));
                break;
            }
            case 1: {
                this.props.dispatch(printTemplate(1));
                break;
            }
        }

        this.props.dispatch(printMode(true));

        setTimeout(this.openPrint, 1000);
    },
    openPrint() {
        window.print();
    },
    render() {

        var color = 'black';

        if (this.state.isOver == true)
            color = '#2196F3';

        var buttonStyle = {
            position: 'absolute',
            backgroundColor: 'white',
            width: this.props.width,
            height: this.props.height,
            display: 'flex',
            alignItems: 'center',
            top: this.props.top,
            left: this.props.left,
            color: 'white',
            borderStyle: 'solid',
            borderWidth: 3,
            borderColor: color
        };

        const iconStyle = {
            position: 'absolute',
            top: 0,
            left: 0,
            width: this.props.width,
            height: this.props.height
        };

        return (
            <div style={buttonStyle} onTouchEnd={this.onClick} onClick={this.onClick} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut}>
                <img alt='' aria-hidden='true' style={iconStyle} src={this.props.src}/>
            </div>
        );
    }
});

export const PrintMenu = React.createClass({
    render() {
        const menuStyle = {
            position: 'absolute',
            top: 0,
            left: 0,
            width: this.props.windowWidth,
            height: this.props.windowHeight,
            overflowX: 'hidden',
            overflowY: 'hidden',
            backgroundColor: 'white'
        };

        const buttonWidth = 140;
        const buttonHeight = 210;
        const gap = 25;
        const holderWidth = 3 * gap + 2 * buttonWidth;
        const holderHeight = 2 * gap + buttonHeight;

        const buttonsHolderStyle = {
            position: 'absolute',
            top: this.props.windowHeight / 2 - holderHeight / 2,
            left: this.props.windowWidth / 2 - holderWidth / 2,
            width: holderWidth,
            height: holderHeight,
            backgroundColor: '#D7D7D7'
        };

        return (
            <div style={menuStyle}>
                <Title width={holderWidth} height={50} top={this.props.windowHeight / 2 - holderHeight / 2 - 50} left={this.props.windowWidth / 2 - holderWidth / 2}/>
                <div style={buttonsHolderStyle}>
                    <Button index={0} width={buttonWidth} height={buttonHeight} left={gap} top={gap} dispatch={this.props.dispatch} src={appParameters.RESOURCES_LOCATION() + 'assets/template1.png'}/>
                    <Button index={1} width={buttonWidth} height={buttonHeight} left={gap * 2 + buttonWidth} top={gap} dispatch={this.props.dispatch} src={appParameters.RESOURCES_LOCATION() + 'assets/template2.png'}/>
                </div>
            </div>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./src/components/menus/PrintMenu.js
 **/